import { Injectable } from '@angular/core';
import { AuthTokenService } from './auth-token.service';

const AWS = require('aws-sdk');

@Injectable({ providedIn: 'root' })
export class S3UploadService {
  private s3: any;
  private credentialsInitialized = false;

  constructor(private auth: AuthTokenService) {}

  private async initCredentials(): Promise<void> {
    const payload = await this.auth.waitForPayload();

    AWS.config.region = payload.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: payload.identityPoolId,
      Logins: {
        [`cognito-idp.${payload.region}.amazonaws.com/${payload.userPoolId}`]: payload.idToken
      }
    });

    await new Promise<void>((resolve, reject) => {
      AWS.config.credentials.refresh((err: any) => (err ? reject(err) : resolve()));
    });

    this.s3 = new AWS.S3();
    this.credentialsInitialized = true;
  }

  async upload(bucket: string, key: string, file: any, contentType: string): Promise<any> {
    if (!this.credentialsInitialized) {
      await this.initCredentials();
    }

    return new Promise((resolve, reject) => {
      const params = {
        Bucket: bucket,
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: contentType
      };

      this.s3.upload(params, (err: any, data: any) => {
        if (err) {
          if (err.code === 'CredentialsError' || err.code === 'ExpiredToken' || err.code === 'NotAuthorizedException') {
            this.credentialsInitialized = false;
            this.auth.invalidate();
          }
          return reject({ error: err });
        }
        return resolve(data);
      });
    });
  }

  async download(bucket: string, key: string): Promise<any> {
    if (!this.credentialsInitialized) {
      await this.initCredentials();
    }

    const params = { Bucket: bucket, Key: key };
    return this.s3.getObject(params).promise();
  }

  getS3File(bucket: string, key: string): Promise<any> {
    return this.download(bucket, key);
  }
}
